import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ValetTypesComponent } from './manage-valet-type.component';

const routes: Routes = [
  { path: '', component: ValetTypesComponent, data: { title: 'Manage Valet Types' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageValetTypeRoutingModule {}

@NgModule({
  imports: [
    ManageValetTypeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ValetTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageValetTypeModule {}
